import { ItemEditContent, type IItemEditArgs } from "@eusoft/webapp-framework";
import { enumItemsSource } from "@eusoft/webapp-ui";
import { PaymentCardType, type Guid,  type ISaleCircuitOptions } from "../../entities/Commands";
import { Icons } from "../../entities/Icons";
import { Authorize } from "../../services/Authorize";
import { context } from "../../services/Context";
import { executeAsync } from "../../services/DataService";
import { WithContext } from "../../services/WithContext";

export interface IEditSaleCircuitOptions extends ISaleCircuitOptions {
    saleCircuitId: Guid;
}

export interface ISaleCircuitOptionsArgs extends IItemEditArgs<IEditSaleCircuitOptions> {
    id: Guid;
}


export const SaleCircuitOptionsPage = ItemEditContent.bulder<IEditSaleCircuitOptions, ISaleCircuitOptionsArgs>()

    .info({
        name: "sale-circuit-options",
        route: "/sale-circuit/{id}/options",
        icon: Icons["options"]
    })

    .feature(WithContext("sale-circuit"))

    .feature(Authorize<ISaleCircuitOptionsArgs>(bld =>
        bld.businessAccount()
            .resource("SaleCircuit", "admin" )))

    .editor(bld => <>

        {bld.singleSelector(a => a.paymentType, {
            editor: {
                itemsSource: enumItemsSource(PaymentCardType)
            }
        })}

    </>, {
        commitMode: "manual",
        style: "vertical",
        inputField: { style: "filled" },
    }
    )

    .options({

        title: "sale-circuit-options",

        style: ["panel"],

        onLoadArgsAsync: async args => {

            if (!args.id)
                args.id = context.saleCircuit?.id;

            const options = await executeAsync("GetSaleCircuitOptions", { id: args.id });

            args.value = {
                ...options,
                saleCircuitId: args.id
            }

            return true;
        },

        onSaveAsync: async value => {

            const res = await executeAsync("SetSaleCircuitOptions", {
                options: value,
                id: value.saleCircuitId
            });

            if (!res)
                return false;

            if (res && value.saleCircuitId == context.saleCircuit?.id)
                context.options = value;
                
            return true;
        }
    }).asContent(); 
